import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Home as HomeIcon, Phone } from 'lucide-react';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import SiteFooter from '../components/SiteFooter';
import { Button } from '../components/ui/button';
import { notFoundPageSEO } from '../data/seo';
import { PRACTICE } from '../data/practice';

const popular = [
  { to: '/invisalign-acton', label: 'Invisalign in Acton' },
  { to: '/implants-acton', label: 'Dental implants' },
  { to: '/composite-bonding-acton', label: 'Composite bonding' },
  { to: '/emergency-dentist-acton', label: 'Emergency dentist' },
  { to: '/pricing', label: 'Fees & prices' },
  { to: '/contact', label: 'Contact & directions' },
];

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white">
      <SEO {...notFoundPageSEO} noindex />
      <PageHeader />
      <main className="pt-32 pb-20 container mx-auto px-4 max-w-3xl text-center" data-testid="not-found-page">
        <p className="text-sm font-semibold uppercase tracking-widest text-[#006A71] mb-3">Error 404</p>
        <h1 className="text-4xl sm:text-5xl font-bold text-rabbit mb-4">We couldn&apos;t find that page</h1>
        <p className="text-lg text-chocolate-malt mb-10">The link may be out of date. Here are the pages patients visit most.</p>
        <div className="grid sm:grid-cols-2 gap-3 text-left mb-10">
          {popular.map((p) => (
            <Link key={p.to} to={p.to} className="flex items-center gap-3 p-4 rounded-xl border border-sky-gray/20 hover:border-burnt-coral text-rabbit font-medium" data-testid={`notfound-link-${p.to.replace(/\//g, '')}`}>
              <Search className="w-4 h-4 text-burnt-coral" aria-hidden="true" />{p.label}
            </Link>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild size="lg" className="bg-burnt-coral hover:bg-burnt-coral/90 text-white"><Link to="/" data-testid="notfound-home-btn"><HomeIcon className="w-5 h-5 mr-2" />Back to homepage</Link></Button>
          <Button asChild size="lg" variant="outline"><a href={PRACTICE.phoneTel}><Phone className="w-5 h-5 mr-2" />Call {PRACTICE.phoneDisplay}</a></Button>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
